module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_pp2_9006.d91c4540.png";